import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import React from 'react';
import { SectionHeadline } from '@/components/SectionHeadline';
import { InfoBoxes } from '@/components/boxes';
import IconWithdrawalDollar from '@/assets/icons/heroIcons/WithdrawalDollar.svg';
import IconShoppingBag from '@/assets/icons/heroIcons/Shopping-bag.svg';
import IconFee from '@/assets/icons/heroIcons/Fee.svg';
import Icon1 from '@/assets/icons/heroIcons/1.svg';
import IconLoan from '@/assets/icons/heroIcons/Loan.svg';
import IconInstallmentsSecondary from '@/assets/icons/heroIcons/Installments-secondary.svg';
import { Button } from '@/components/buttons';
import { LINKS } from '@/constants/links';
export function DontUseBNPL() {
  const $ = _c(69);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["shopWisely"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  let t1;
  if ($[1] !== t) {
    t1 = t("dontUseBNPL.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline anchorKey="dontUseBNPL.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dontUseBNPL.items.1.title");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("dontUseBNPL.items.1.text");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <IconWithdrawalDollar />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t4) {
    t6 = {
      title: t3,
      paragraph: t4,
      icon: t5
    };
    $[10] = t3;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("dontUseBNPL.items.2.title");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t("dontUseBNPL.items.2.text");
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <IconShoppingBag />;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t8) {
    t10 = {
      title: t7,
      paragraph: t8,
      icon: t9
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t("dontUseBNPL.items.3.title");
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t("dontUseBNPL.items.3.text");
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconFee />;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t12) {
    t14 = {
      title: t11,
      paragraph: t12,
      icon: t13
    };
    $[26] = t11;
    $[27] = t12;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("dontUseBNPL.items.4.title");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t) {
    t16 = t("dontUseBNPL.items.4.text");
    $[31] = t;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <IconInstallmentsSecondary />;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t15 || $[35] !== t16) {
    t18 = {
      title: t15,
      paragraph: t16,
      icon: t17
    };
    $[34] = t15;
    $[35] = t16;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t) {
    t19 = t("dontUseBNPL.items.5.title");
    $[37] = t;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t) {
    t20 = t("dontUseBNPL.items.5.text");
    $[39] = t;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <IconLoan />;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t19 || $[43] !== t20) {
    t22 = {
      title: t19,
      paragraph: t20,
      icon: t21
    };
    $[42] = t19;
    $[43] = t20;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== t) {
    t23 = t("dontUseBNPL.items.6.title");
    $[45] = t;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t) {
    t24 = t("dontUseBNPL.items.6.text");
    $[47] = t;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Icon1 />;
    $[49] = t25;
  } else {
    t25 = $[49];
  }
  let t26;
  if ($[50] !== t23 || $[51] !== t24) {
    t26 = {
      title: t23,
      paragraph: t24,
      icon: t25
    };
    $[50] = t23;
    $[51] = t24;
    $[52] = t26;
  } else {
    t26 = $[52];
  }
  let t27;
  if ($[53] !== t10 || $[54] !== t14 || $[55] !== t18 || $[56] !== t22 || $[57] !== t26 || $[58] !== t6) {
    t27 = <InfoBoxes items={[t6, t10, t14, t18, t22, t26]} variant="basic" />;
    $[53] = t10;
    $[54] = t14;
    $[55] = t18;
    $[56] = t22;
    $[57] = t26;
    $[58] = t6;
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  let t28;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = LINKS();
    $[60] = t28;
  } else {
    t28 = $[60];
  }
  const t29 = t28.registration;
  let t30;
  if ($[61] !== t) {
    t30 = t("dontUseBNPL.cta");
    $[61] = t;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== t30) {
    t31 = <Button to={t29} analyticsParam="shopWiselyRegistration" testId="shopWiselyRegistration" variant="primary" size="lg" align="center">{t30}</Button>;
    $[63] = t30;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== t2 || $[66] !== t27 || $[67] !== t31) {
    t32 = <div className="flex flex-col gap-10 px-4 lg:gap-16">{t2}{t27}{t31}</div>;
    $[65] = t2;
    $[66] = t27;
    $[67] = t31;
    $[68] = t32;
  } else {
    t32 = $[68];
  }
  return t32;
}